import React, { useEffect, useMemo, useState } from 'react';

const ponto = (p, q, t) => {
  const mx = (p.x + q.x) / 2;
  const c = [p, { x: mx, y: p.y }, { x: mx, y: q.y }, q];
  const u = 1 - t;
  const w = [u * u * u, 3 * u * u * t, 3 * u * t * t, t * t * t];
  return {
    x: c.reduce((s, k, i) => s + k.x * w[i], 0),
    y: c.reduce((s, k, i) => s + k.y * w[i], 0),
  };
};

// tanque do jogador percorrendo a trilha até o ícone da fase atual
export const GbTank = ({ from, to, size = 40 }) => {
  const [t, setT] = useState(from ? 0 : 1);
  useEffect(() => {
    if (!from) { setT(1); return undefined; }
    const dur = 3400, pausa = 1400;
    let raf, ini = null;
    const loop = (ts) => {
      if (ini === null) ini = ts;
      const dt = (ts - ini) % (dur + pausa);
      setT(Math.min(1, dt / dur));
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [from, to]);

  const pos = useMemo(() => (from ? ponto(from, to, t) : to), [from, to, t]);
  if (!to) return null;
  return (
    <span data-testid="gb-tank" aria-hidden
      style={{ left: `${pos.x}%`, top: `${pos.y}%`, width: size, height: size }}
      className="pointer-events-none absolute z-20 -translate-x-1/2 -translate-y-[115%]">
      <img src="/gb/world/tank.png" alt="" draggable="false"
        className="h-full w-full object-contain drop-shadow-[0_4px_8px_rgba(0,0,0,.7)]" />
    </span>
  );
};

// brasão dourado da região dominada (12 estrelas)
export const GbCrest = ({ className = 'h-7 w-7' }) => (
  <svg viewBox="0 0 40 46" className={`${className} drop-shadow-[0_2px_6px_rgba(255,190,60,.7)]`}>
    <defs>
      <linearGradient id="gbcrest" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffe89a" />
        <stop offset="0.5" stopColor="#f2b431" />
        <stop offset="1" stopColor="#a86513" />
      </linearGradient>
    </defs>
    <path d="M20 1 L38 7 C38 26, 31 39, 20 45 C9 39, 2 26, 2 7 Z"
      fill="url(#gbcrest)" stroke="#5c3306" strokeWidth="1.6" />
    <path d="M20 12 l3.1 6.5 7 .9 -5.1 4.9 1.3 7 -6.3-3.5 -6.3 3.5 1.3-7 -5.1-4.9 7-.9 Z"
      fill="#3c1f04" opacity=".85" />
  </svg>
);
